import React from 'react';
import DisclaimerBox from '../components/DisclaimerBox';

const TERMS = [
  { t: 'Research Purposes Only', d: 'All products are supplied strictly for research and laboratory purposes only. They are not for human consumption.' },
  { t: 'Not For Human Consumption', d: 'Products are not intended to diagnose, treat, cure or prevent any disease. They must not be ingested or administered to humans or animals.' },
  { t: 'No Medical Advice', d: 'We provide no medical, dosing, or usage advice. No information on this site constitutes medical guidance.' },
  { t: 'No Therapeutic Claims', d: 'No therapeutic, performance, weight-loss or health claims are made about any product. No medical claims are made.' },
  { t: 'Customer Responsibility', d: 'By purchasing, the customer confirms they are a qualified researcher and accept full responsibility for lawful handling, storage and use of products for research purposes only.' },
  { t: 'No Refunds or Returns', d: 'Due to the nature of the products, no refunds or returns are available once payment is completed.' },
  { t: 'Shipping Delays', d: 'While we dispatch promptly, we are not liable for carrier delays outside our control.' },
  { t: 'Dispatch', d: 'All items are held in stock and typically dispatch within 1\u20132 business days of payment confirmation.' },
  { t: 'Australia-Only Sales', d: 'We sell and ship within Australia only. International orders cannot be accepted.' },
  { t: 'Payment Acknowledgement', d: 'By completing payment, the customer acknowledges and accepts all terms, including the research-use and no-refund conditions.' },
];

export default function Terms() {
  return (
    <div className="bg-alp-black min-h-screen">
      <div className="border-b border-alp-line">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 text-center">
          <p className="text-alp-gold text-xs tracking-[0.3em] uppercase mb-3">Legal</p>
          <h1 className="font-serif text-5xl md:text-6xl text-alp-cream">Terms &amp; Conditions</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-16">
        <div className="space-y-8">
          {TERMS.map((s, i) => (
            <div key={i}>
              <h3 className="font-serif text-2xl text-alp-cream mb-2"><span className="text-alp-gold/60">{String(i + 1).padStart(2, '0')}.</span> {s.t}</h3>
              <p className="text-alp-gray leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-12"><DisclaimerBox /></div>
      </div>
    </div>
  );
}
